import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { AppointmentInfo, Layout, Modal } from "components";
import { useSelector, useDispatch, batch } from "react-redux";
import {
  appointmentBooking,
  changeAppointmentBooking
} from "services/api-service";
import {
  changeRegisteredAppointmentId,
  changeRegisteredApptTimeslotId,
  changeDisplaySelectedDate,
  changeDisplaySelectedTime,
  changeBookingTxnId,
  changeTransTime
} from "redux/appointmentBooking";

import {
  YEAR_MONTH_DAY_HOUR_MINUTE_SECOND,
  YEAR_MONTH_DAY_HOUR_MINUTE
} from "constants/date";
import moment from "moment";

import {
  DEFAULT_ROUTE,
  CALL_APPOINTMENT_ACKNOWLEDGEMENT
} from "constants/route";

const YES = "1";

export default function CallApptBookingConfirmation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [titleMessage, setTitleMessage] = useState("");
  const [bodyMessage, setBodyMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const goHome = () => navigate(DEFAULT_ROUTE);

  const { enquiryId, nric, age, language, service, mobile } = useSelector(
    (state) => state.appointment
  );

  const { mainId, subServiceId, mainWebDisplayText } = useSelector(
    (state) => state.services
  );

  const {
    selectedDate,
    selectedTimeSlot,
    selectedService,
    selectedApptType,
    attendingWithAnother,
    registeredAppointmentId,
    registeredApptTimeslotId,
    bookingTxnId,
    defaultLocationId,
    anotherNric,
    anotherSelectedTimeSlot
  } = useSelector((state) => state.appointmentBooking);

  const appointmentInfo = {
    idType: "NRIC/FIN/AccountNo",
    idNo: `${nric}`,
    scheme: `${mainWebDisplayText}`,
    mode: `${selectedApptType.label}`,
    date: `${selectedDate}`,
    time: `${selectedTimeSlot.label}`
  };

  const contactNo = `${mobile}`;

  const onConfirm = () => {
    setErrorMessage("");
    setTitleMessage("Are you sure ?");
    setBodyMessage("Your filling data will be deleted.");
    setIsOpenModal(true);
  };

  const onHideModal = () => setIsOpenModal(false);

  const footer = errorMessage ? (
    <Button variant="danger" onClick={onHideModal}>
      OK
    </Button>
  ) : (
    <>
      <Button variant="secondary" onClick={onHideModal}>
        Cancel
      </Button>
      <Button variant="primary" onClick={goHome}>
        Confirm
      </Button>
    </>
  );

  useEffect(() => onSubmit(), []);

  const onSubmit = async () => {
    try {
      let response;

      const appointmentDate = moment(
        `${selectedDate} ${selectedTimeSlot.label}`,
        YEAR_MONTH_DAY_HOUR_MINUTE
      ).format(YEAR_MONTH_DAY_HOUR_MINUTE_SECOND);

      const anotherAppointmentDate =
        attendingWithAnother === YES
          ? moment(
              `${selectedDate} ${anotherSelectedTimeSlot.label}`,
              YEAR_MONTH_DAY_HOUR_MINUTE
            ).format(YEAR_MONTH_DAY_HOUR_MINUTE_SECOND)
          : "";

      const birthYear = moment(age).year();

      registeredAppointmentId && registeredApptTimeslotId
        ? (response = await changeAppointmentBooking(
            mainId,
            subServiceId,
            enquiryId,
            nric,
            birthYear,
            language,
            service,
            mobile,
            selectedApptType.value,
            attendingWithAnother,
            defaultLocationId,
            appointmentDate,
            Number(selectedTimeSlot.value),
            Number(registeredAppointmentId),
            Number(registeredApptTimeslotId),
            anotherNric ? anotherNric : "",
            anotherAppointmentDate,
            anotherSelectedTimeSlot.value,
            bookingTxnId
          ))
        : (response = await appointmentBooking(
            mainId,
            subServiceId,
            enquiryId,
            nric,
            birthYear,
            language,
            service,
            mobile,
            selectedApptType.value,
            attendingWithAnother,
            defaultLocationId,
            appointmentDate,
            Number(selectedTimeSlot.value),
            anotherNric ? anotherNric : "",
            anotherSelectedTimeSlot.value,
            anotherAppointmentDate,
            selectedService.label
          ));

      if (response.status === 200) {
        batch(() => {
          dispatch(changeRegisteredAppointmentId(response.data[0].id));
          dispatch(changeRegisteredApptTimeslotId(selectedTimeSlot.value));
          dispatch(changeDisplaySelectedDate(selectedDate));
          dispatch(changeDisplaySelectedTime(selectedTimeSlot.label));
          dispatch(changeBookingTxnId(response.data[0].bookingTxnId));
          dispatch(changeTransTime(response.data[0].time));
        });
        navigate(CALL_APPOINTMENT_ACKNOWLEDGEMENT);
      }
    } catch (error) {
      setIsOpenModal(true);
      setTitleMessage("Error");
      setErrorMessage(error.response.data.error);
    }
  };

  return (
    <></>
    // <Layout>
    //   <div className="form-box my-5">
    //     <div className="center mt-3">
    //       <h3 className="text-secondary">Contact Us</h3>
    //       <div className="text-secondary">
    //         Please review the details of your appointment
    //       </div>
    //       <div className="text-secondary">
    //         and click the 'Next' button below to secure your appointment.
    //       </div>
    //     </div>
    //     <AppointmentInfo
    //       appointmentInfo={appointmentInfo}
    //       contactNo={contactNo}
    //     />

    //     <div className="form-footer">
    //       <Button
    //         className="btn cmp-button pbs-style--primary rounded-pill me-3"
    //         onClick={onConfirm}
    //       >
    //         Home Page
    //       </Button>
    //       <Button
    //         className="btn cmp-button pbs-style--primary rounded-pill "
    //         onClick={onSubmit}
    //       >
    //         Next
    //       </Button>
    //     </div>

    //     <Modal
    //       isOpen={isOpenModal}
    //       onHide={onHideModal}
    //       titleClassName={errorMessage && "text-danger"}
    //       title={titleMessage}
    //       body={errorMessage ? errorMessage : bodyMessage}
    //       footer={footer}
    //     />
    //   </div>
    // </Layout>
  );
}
